import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import SiteLayout from "@/components/site/SiteLayout";
import RoomCard from "@/components/site/RoomCard";
import BookingWidget from "@/components/site/BookingWidget";
import Seo from "@/components/Seo";
import { api } from "@/lib/api";
import { useI18n } from "@/lib/i18n";

export default function RoomsPage() {
  const [params] = useSearchParams();
  const { t } = useI18n();
  const [rooms, setRooms] = useState([]);
  const [loading, setLoading] = useState(true);
  const guests = Number(params.get("guests") || 0);
  const query = params.toString() ? `?${params.toString()}` : "";

  useEffect(() => {
    api.get("/rooms")
      .then((r) => {
        let list = r.data;
        if (guests > 0) list = list.filter((rm) => rm.max_guests >= guests);
        setRooms(list);
      })
      .finally(() => setLoading(false));
  }, [guests]);

  return (
    <SiteLayout>
      <Seo title={`${t("rooms.title")} · Berdhill Rooms`} description={t("rooms.subtitle")} />
      <section className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12 pt-12 pb-10">
        <div className="text-xs tracking-[0.2em] uppercase text-brand-muted">{t("home.staywithus")}</div>
        <h1 className="font-display text-5xl md:text-6xl mt-3 leading-tight">{t("rooms.title")}</h1>
        <p className="mt-4 text-brand-muted max-w-xl">{t("rooms.subtitle")}</p>
        <div className="mt-10"><BookingWidget /></div>
      </section>

      <section className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12 pt-8 pb-24">
        {loading ? (
          <div className="text-center text-brand-muted py-20">Loading rooms…</div>
        ) : rooms.length === 0 ? (
          <div className="text-center py-20" data-testid="rooms-empty">
            <p className="font-display text-3xl">{t("rooms.empty")}</p>
            <p className="text-brand-muted mt-2">{t("rooms.empty_hint")}</p>
          </div>
        ) : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-10" data-testid="rooms-grid">
            {rooms.map((r) => <RoomCard key={r.id} room={r} query={query} />)}
          </div>
        )}
      </section>
    </SiteLayout>
  );
}
